// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 88494, offsets 193536:194556. Structure and names inferred from code, not screenshots.

import * as React from "react";
function usePageTracking(e, t, i, a = {}) {
  let { reportOnUnmount: r = false, reportOnBeforeUnload: l = false } = a,
    s = (0, React.useRef)(Date.now()),
    c = (0, React.useRef)(false),
    d = (0, React.useRef)(e),
    u = (0, React.useRef)(t),
    p = (0, React.useRef)(i),
    m = (0, React.useRef)({
      reportOnUnmount: r,
      reportOnBeforeUnload: l,
    });
  ((d.current = e),
    (u.current = t),
    (p.current = i),
    (m.current = {
      reportOnUnmount: r,
      reportOnBeforeUnload: l,
    }));
  let h = (0, React.useCallback)(() => {
      let e = (Date.now() - s.current) / 1e3;
      if (c.current || e < 0.05) return;
      c.current = true;
      let t = "function" == typeof p.current ? p.current() : p.current;
      d.current(
        "track",
        u.current,
        t
          ? {
              duration: e,
              ...t,
            }
          : {
              duration: e,
            },
      );
    }, []),
    g = (0, React.useCallback)(() => {
      ((s.current = Date.now()), (c.current = false));
    }, []);
  return (
    (0, React.useEffect)(() => {
      ((s.current = Date.now()), (c.current = false));
      let e = () => {
        m.current.reportOnBeforeUnload && h();
      };
      return (
        m.current.reportOnBeforeUnload &&
          window.addEventListener("beforeunload", e),
        () => {
          (m.current.reportOnBeforeUnload &&
            window.removeEventListener("beforeunload", e),
            m.current.reportOnUnmount && h());
        }
      );
    }, [h]),
    {
      report: h,
      reset: g,
    }
  );
}
export { usePageTracking };
